/**
 * @generated SignedSource<<e1dc00d7e79445a719491e97bac509e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type accessGate_RevealMutation$variables = Record<PropertyKey, never>;
export type accessGate_RevealMutation$data = {
  readonly accountDataReveal: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly user: {
      readonly dataRevealedAt: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type accessGate_RevealMutation = {
  response: accessGate_RevealMutation$data;
  variables: accessGate_RevealMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataRevealedAt",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accessGate_RevealMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountDataRevealMutationPayload",
        "kind": "LinkedField",
        "name": "accountDataReveal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accessGate_RevealMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountDataRevealMutationPayload",
        "kind": "LinkedField",
        "name": "accountDataReveal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ae59eeddb0ae3aec7a1b942e55a4431",
    "id": null,
    "metadata": {},
    "name": "accessGate_RevealMutation",
    "operationKind": "mutation",
    "text": "mutation accessGate_RevealMutation {\n  accountDataReveal {\n    user {\n      dataRevealedAt\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d580d8a68277b385bc38f5c91ab70de";

export default node;
